// extracted by mini-css-extract-plugin
export default {"error-banner":"ErrorBanner_error-banner__GYGwW","error-message":"ErrorBanner_error-message__hkYPa","close-icon":"ErrorBanner_close-icon__G2VoL"};